<script>
import tableComp from "@/compositions/modules/table";
import formComp from "@/compositions/modules/form";
import { CollectionReq } from "@/domain/modules/list";
import SrTblColumn from "@/components/SrTblColumn";
import { components } from "@libs/ui";
import { ref, reactive } from "vue";
import { fetchCollection, listByAcctName } from "@/api/modules/list";
import { formatMoney } from "@/utils";
import { downloadFile } from "@/utils/download";
import { list } from '@/api/url'
import { useI18n } from "@/plugins/i18n";
import { dataUtils,vab } from "@libs/utils";
import { RSP_ITEM_TYPE } from '@/domain/base'

export default {
  components: {
    SrTblColumn,
    SrTblPagination: components.SrTblPagination,
  },
  setup() {
    const { t } = useI18n();
    const { tbl, fetchData, formReq, curEnum, acctStatEnum, statTag } = initTable();
    const { handleSelect, selectList } = initForm();
    const handleSearch = () => fetchData();
    const downloadList = async () => {
      await downloadFile(list.collectionExport, formReq.fields)
    }
    const emptyImg = ref(require("@/assets/img/dashboard/empty.png"));
    return {
      tbl,
      fetchData,
      emptyImg,
      formReq,
      t,
      handleSearch,
      handleSelect,
      selectList,
      curEnum,
      acctStatEnum,
      statTag,
      dataUtils,
      downloadList
    };
  },
};

// 初始化table
const initTable = () => {
  const { createTable } = tableComp();
  const { formReq } = initForm();
  const { t } = useI18n();
  const columnsTemp = [
    { prop: "noticeSq", label: t("collection.table.text_3") },
    { slot: "acctId", align: "left", label: t("collection.table.text_2") },
    { prop: "inviteCode", label: t('dashboard.table.text_7') },
    { prop: "transinAmt", label: t("collection.table.text_4"), type: RSP_ITEM_TYPE.AMOUNT, depend: 'transinCur', align: "right" },
    // { prop: "feeAmt", label: t("collection.table.text_7"), type: RSP_ITEM_TYPE.AMOUNT, depend: 'transinCur', align: "right" },
    { slot: "createDatetime", label: t("collection.table.text_6"), align: "center", headerSlot: 'createDate'},
    { prop: "completeDate", label: t("collection.table.text_8"), align: "center", headerSlot: 'completeDatetime' },
    { slot: 'noticeStat', label: t('trade.table.text_12') },

    // { prop: 'transinUsdAmt', align: 'right', label: '入账金额折美' },
  ];
  const acctStatEnum = {
    2: t('collection.status.pending'),
    3: t('collection.status.credited'),
    4: t('collection.status.returning'),
    5: t('collection.status.returned'),
  }
  const statTag = {
    2: 'primary',
    3: 'success',
    4: 'primary',
    5: 'success',
  }
  const tbl = createTable({ columns: columnsTemp });

  const curEnum = [
    "USD",
    "CNH",
    "CNY",
    "HKD",
    "GBP",
    "EUR",
    "JPY",
    "CAD",
    "AUD",
    "NZD",
    "SGD",
    "CHF",
    "AED",
    "THB",
    "SEK",
    "NOK",
    "VND",
    "MYR",
    "PHP",
    "KRW",
    "IDR",
    "BHD",
    "ZAR",
    "KES",
  ];

  const fetchData = async () => {
    const params = {
      pageInfo: {
        current: tbl.pagination.currentPage,
        size: tbl.pagination.pageSize,
      },
      acctId: formReq.fields.acctId || "",
      inviteCode: formReq.fields.inviteCode || "",
      transinCur: formReq.fields.transinCur || "",
      sysTxnDate: formReq.fields.sysTxnDate || [],
      noticeStatList: formReq.fields.noticeStatList || [],
    };
    // if (!checkParam(params)) {
    //   return;
    // }
    tbl.data.loading = true;
    tbl.data.list = [];
    try {
      const res = await fetchCollection(params);
      tbl.data.list = res.list.map((item) => ({
        ...item,
        transinAmt: formatMoney(item.transinAmt),
        transinUsdAmt: formatMoney(item.transinUsdAmt),
        createDatetime: dataUtils.formatDate(
          item.createDatetime,
          "YYYY-MM-DD HH:mm:ss"
        ),
      }));
      tbl.pagination.total = res.pageInfo.total;
    } finally {
      tbl.data.loading = false;
    }
  };
  const checkParam = (param) => {
    let res = true;
    if (!param.acctId) {
      let date = param.sysTxnDate;
      if (date && date[0]) {
        let nowDate = new Date();
        let limit = new Date(nowDate.setDate(nowDate.getDate() - 90));
        if (date && new Date(date[0]) < limit) {
          vab.baseMessage("日期请选择90天以内的日期搜索", "error");

          return false;
        }
      } else {
        vab.baseMessage("请选择客户或选择90天以内的日期搜索", "error");

        return false;
      }
    }

    return res;
  };
  fetchData();
  return { tbl, formReq, fetchData, curEnum, acctStatEnum, statTag};
};

// 初始化form
const initForm = () => {
  const { createForm } = formComp();
  const formReq = reactive({
    ...createForm({ items: CollectionReq }),
  });

  
  let nowDate = new Date();
  let limit = new Date(nowDate.setDate(nowDate.getDate() - 90));
  formReq.fields.sysTxnDate=[dataUtils.formatDate(limit,"YYYY-MM-DD"),dataUtils.formatDate(new Date(),"YYYY-MM-DD")]

  // 处理下拉框
  const selectList = ref([]);
  const handleSelect = (e) => {
    const fetchData = async () => {
      const res = await listByAcctName({ acctName: e });
      selectList.value = res.list.map((item) => ({
        ...item,
        label: item.acctName,
        value: item.acctId,
      }));
    };

    fetchData();
  };
  return { formReq, handleSelect, selectList };
};
</script>

<template>
  <div class="table-container">
    <div class="h1">{{t('enum.text_3')}}</div>
    <div class="sr-container__content sr-container__content--row">
      <el-form :model="formReq.fields"
        inline
        :label-width="localCN?'100px':'160px'"
        label-position="left">
        <el-form-item :label="formReq.schema.acctName.label">
          <el-select v-model="formReq.fields.acctId"
            filterable
            clearable
            remote
            :remote-method="e=>handleSelect(e)">
            <el-option v-for="item in selectList"
              :key="item.value"
              :label="item.label"
              :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item :label="formReq.schema.inviteCode.label">
          <el-input v-model="formReq.fields.inviteCode" :placeholder="formReq.schema.inviteCode.placeholder" />
        </el-form-item>
        <el-form-item :label="formReq.schema.transinCur.label">
          <el-select v-model="formReq.fields.transinCur" clearable>
            <el-option v-for="item in curEnum"
              :label="item"
              :value="item"
              :key="item" />
          </el-select>
        </el-form-item>
        <el-form-item :label="formReq.schema.noticeStatList.label">
          <el-select v-model="formReq.fields.noticeStatList" multiple :placeholder="formReq.schema.noticeStatList.placeholder">
            <el-option v-for="(value,key) in acctStatEnum" :key="key" :label="value" :value="key" />
          </el-select>
        </el-form-item>
        <el-form-item :label="formReq.schema.sysTxnDate.label">
          <el-date-picker v-model="formReq.fields.sysTxnDate"
            type="daterange"
            unlink-panels
            range-separator="-"
            value-format="YYYY-MM-DD"
            :start-placeholder="t('components.datepicker.start')"
            :end-placeholder="t('components.datepicker.end')">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            @click="handleSearch">{{t('collection.content.text_1')}}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadList">{{t('client.content.text_6')}}</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <el-table row-class-name="row-con"
      :data="tbl.data.list"
      v-loading="tbl.data.loading">
      <sr-tbl-column :columns="tbl.columns">
        <template #acctId="scope">
          <div class="header-cell">
            <div>{{scope.row.acctName}}</div>
            <div>{{scope.row.acctId}}</div>
          </div>
        </template>
        <template #createDatetime="scope">
          <div class="header-cell">
            <div>{{ dataUtils.formatDate(scope.row.createDatetime, "YYYY-MM-DD") }}</div>
            <div>{{ dataUtils.formatDate(scope.row.createDatetime, "HH:mm:ss")}}</div>
          </div>
        </template>
        <template #noticeStat="scope">
          <div class="header-cell">
            <el-tag v-if="scope.row.noticeStat" :type="statTag[scope.row.noticeStat]">
              {{acctStatEnum[scope.row.noticeStat]}}
            </el-tag>
            <span v-else>-</span>
          </div>
        </template>
        <template #completeDatetime>
          <div class="header-cell">
            <span>{{  t("collection.table.text_8")}}</span>
            <el-tooltip effect="dark" placement="top">
              <template #content>
                {{ t("collection.tips.text_2") }}
              </template>
              <el-icon><InfoFilled /></el-icon>
            </el-tooltip>
          </div>
        </template>
        <template #createDate>
          <div class="header-cell">
            <span>{{  t("collection.table.text_6")}}</span>
            <el-tooltip effect="dark" placement="top">
              <template #content>
                {{ t("collection.tips.text_1") }}
              </template>
              <el-icon><InfoFilled /></el-icon>
            </el-tooltip>
          </div>
        </template>
      </sr-tbl-column>
      <template #empty>
        <div class="empty-wrap">
          <img :src="emptyImg"
            alt="">
          {{t('collection.content.text_2')}}
        </div>
      </template>
    </el-table>
    <sr-tbl-pagination v-model:current-page="tbl.pagination.currentPage"
      v-model:page-size="tbl.pagination.pageSize"
      :total="tbl.pagination.total"
      @fetchData="fetchData">
    </sr-tbl-pagination>
  </div>
</template>

<style lang="scss" scoped rel="stylesheet/scss">
.table-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 4px;
  padding: 30px 20px;

  .empty-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 160px auto;
    box-sizing: border-box;

    & > img {
      width: 190px;
      height: auto;
      display: block;
      margin-bottom: 38px;
    }
  }

  :deep(.row-con) {
    height: 57px;
  }
}
</style>
